type callInfo = {
  a?: string;
  functionname?: string;
  callback?: string;
  args?: any;
};

function createCallbackFunction(funcName, callbackFunc, bCreateCallback) {
  if (callbackFunc && callbackFunc.name && callbackFunc.name.length > 0) {
    return callbackFunc.name;
  }

  /** 在原生打开h5页面，h5页面又内嵌iframe，iframe里调了原生提供的方法的场景下，callbackFunc需要被挂载到顶级窗口的window对象下，否则不会被调用 */
  const topWindow: any = window.top;

  if (!topWindow?.__functionIndexMap) {
    topWindow.__functionIndexMap = {};
  }

  if (typeof topWindow[funcName + 0] != 'function') {
    topWindow[funcName + 0] = callbackFunc;
    topWindow.__functionIndexMap[funcName] = 0;
    return funcName + 0;
  } else {
    if (!bCreateCallback) {
      const maxIndex = topWindow.__functionIndexMap[funcName];
      const callbackFuncStr = callbackFunc.toString();
      for (let i = 0; i <= maxIndex; i++) {
        const tmpName = funcName + i;
        if (topWindow[tmpName].toString() == callbackFuncStr) return tmpName;
      }
    }

    const newIndex = ++topWindow.__functionIndexMap[funcName];
    topWindow[funcName + newIndex] = callbackFunc;
    return funcName + newIndex;
  }
}

function createIFrame(src) {
  const rootElm = document.documentElement;
  const newFrameElm = document.createElement('IFRAME');
  newFrameElm.setAttribute('src', src);
  rootElm.appendChild(newFrameElm);
  return newFrameElm;
}

export default function callAppFunction(functionName: string, args?, callback?, bCreateCallback?) {
  //如果 url 是 /support/preheat，则不调用原生
  if (window.location.pathname.includes('support/preheat')) {
    return;
  }
  // creates a JSON string from function name and arguments and then calls openCustomURLinIFrame.
  let url = 'js2app://';

  const callInfo: callInfo = {};
  callInfo.a = 'aa/aa';
  callInfo.functionname = functionName;
  if (callback) {
    if (typeof callback == 'function') {
      const callbackFuncName = createCallbackFunction(functionName + '_' + 'callback', callback, bCreateCallback);
      callInfo.callback = callbackFuncName;
    } else callInfo.callback = callback;
  }
  if (args) {
    callInfo.args = args;
  }
  url += encodeURIComponent(JSON.stringify(callInfo));
  url = url.replace('aa%2Faa', 'aa/aa');

  const iFrame = createIFrame(url);
  // remove the frame now
  iFrame.parentNode.removeChild(iFrame);
}

export function callAppFunctionMock(functionName, args, callback, bCreateCallback) {
  if (functionName === 'getSupportedList') {
    callback({
      result: true,
      object: {
        supported: ['WeChatSession', 'WeChatMoments', 'facebook', 'saveImage', 'copyLink']
      }
    });
  }
}
